import $ from 'jquery';

/** Internal Dependencies */
import { NCST } from '../';
import { ControllerComponent } from './ControllerComponent';

export default class MobileMenu extends ControllerComponent {
	constructor() {
		super();

		this.elements = {
			menuList: $( '.mobile-nav__menu' ),
			topLevelItems: $( '.mobile-nav__menu > .menu-item > a' ),
			subMenus: $( '.mobile-nav__menu .sub-menu' ),
			currentPageItem: $(
				'.mobile-nav__menu .sub-menu > .current_page_item'
			),
		};

		this.state = {
			menuActive: false,
			activeItem: null,
			subMenuStyle: {},
		};

		this.menuTimeout = null;

		this.setSubMenuStyle = this.setSubMenuStyle.bind( this );
		this.setSubMenuState = this.setSubMenuState.bind( this );
		this.handleTopLevelClick = this.handleTopLevelClick.bind( this );
		this.handleMouseIn = this.handleMouseIn.bind( this );
		this.handleMouseOut = this.handleMouseOut.bind( this );
		this.handleSubMenuTransitions = this.handleSubMenuTransitions.bind(
			this
		);
		this.deploySubMenu = this.deploySubMenu.bind( this );
		this.reset = this.reset.bind( this );
		this.applySubReset = this.applySubReset.bind( this );
		this.applySubTransition = this.applySubTransition.bind( this );
	}

	init() {
		// Set up handlers
		this.elements.topLevelItems.hover(
			this.handleMouseIn,
			this.handleMouseOut
		);

		if ( this.elements.subMenus.length > 0 ) {
			this.elements.topLevelItems.click( this.handleTopLevelClick );
		}

		NCST.elements.$win.on(
			'ncst_header_content_shown',
			this.setSubMenuState
		);
		NCST.elements.$win.on( 'ncst_resized', this.setSubMenuStyle );
	}

	setSubMenuStyle() {
		this.setState( {
			subMenuStyle: this.getSubMenuStyle(),
		} );
	}

	setSubMenuState() {
		let activeItem = null;

		if ( this.elements.currentPageItem.length > 0 ) {
			/**
			 * Locates the parent page item.
			 *
			 * Relying on menu item heirarchy can cause multiple top level items to be
			 * "active". We check the .current-page-parent class to ensure that only
			 * the current page's parent page is set as active. We also must use the
			 * kebab case selector for identifying the parent because the snake case
			 * selector inaccuratly describes page heirarcy. Conversely, we use snake
			 * case to identify the current page item because a kebab case version is
			 * not generated.
			 */
			const ancestor = this.elements.currentPageItem.parents(
				'.menu-item.current-page-parent, .menu-item.current_page_item'
			);

			if ( ancestor.length > 0 ) {
				activeItem = ancestor;
			}
		}

		this.setState( {
			menuActive: activeItem !== null,
			activeItem: activeItem,
			subMenuStyle: this.getSubMenuStyle(),
		} );
	}

	getSubMenuStyle() {
		var screenWidth = NCST.elements.$win.width();
		var mainMenuWidth = this.elements.menuList.outerWidth();
		var subMenuWidth = screenWidth - mainMenuWidth;

		// Minimum of 200px wide
		subMenuWidth = subMenuWidth < 200 ? 200 : subMenuWidth;

		var stacked = mainMenuWidth + subMenuWidth > screenWidth;

		return {
			stacked: stacked,
			left: mainMenuWidth,
			width: subMenuWidth,
		};
	}

	handleTopLevelClick( e ) {
		const href = e.target.attributes[0].textContent;
		( href === '#' ) && e.preventDefault(); // Prevent default only if link is # (hash)

		const item = $( e.target ).parents( '.menu-item.menu-item-has-children' );
		
		if (
			item.is( this.state.activeItem ) &&
			this.state.subMenuStyle.stacked
		) {
			this.reset();
			return;
		}

		this.deploySubMenu( item );
	}

	handleMouseIn( e ) {
		if ( this.state.subMenuStyle.stacked ) return;

		const item = $( e.target ).parent( '.menu-item' );

		if ( ! item.hasClass( 'active' ) && ! this.state.menuActive ) {
			this.deploySubMenu( item );
		} else if ( ! item.hasClass( 'active' ) && this.state.menuActive ) {
			this.menuTimeout = setTimeout(
				function () {
					this.deploySubMenu( item );
				}.bind( this ),
				250
			);
		}
	}

	handleMouseOut() {
		if ( this.state.subMenuStyle.stacked ) return;

		clearTimeout( this.menuTimeout );
	}

	deploySubMenu( item ) {
		this.setState( {
			menuActive: true,
			activeItem: item,
		} );
	}

	reset() {
		this.setState( {
			menuActive: false,
			activeItem: null,
		} );
	}

	applySubReset( prev ) {
		if ( this.state.subMenuStyle.stacked ) {
			prev.find( '.sub-menu' ).animate( {
				height: 'toggle',
			} );
			prev.removeClass( 'active' );
		} else {
			prev.find( '.sub-menu' ).fadeOut(
				200,
				( function ( prev ) {
					prev.removeClass( 'active' );
				} )( prev )
			);
		}
	}

	applySubTransition( prev ) {
		let $prevSub = prev.find( '.sub-menu' );
		let $activeSub = this.state.activeItem.find( '.sub-menu' );

		if ( this.state.subMenuStyle.stacked ) {
			if ( prev.length > 0 && $prevSub.length > 0 ) {
				$prevSub.animate( {
					height: 'toggle',
				} );
			}

			$activeSub.animate( {
				height: 'toggle',
			} );
		} else {
			if ( prev.length > 0 && $prevSub.length > 0 ) {
				$prevSub.fadeOut( 200, function () {
					$activeSub.fadeIn( 200 );
				} );
			} else {
				$activeSub.fadeIn( 200 );
			}
		}

		prev.removeClass( 'active' );
		this.state.activeItem.addClass( 'active' );
	}

	handleSubMenuTransitions() {
		var $prevActive = $( '.mobile-nav__menu .menu-item.active' );

		// Only do work if the active item has changed and menu is active
		if (
			! $prevActive.is( this.state.activeItem ) &&
			this.state.menuActive
		) {
			this.applySubTransition( $prevActive );
		} else if ( ! this.state.menuActive ) {
			this.applySubReset( $prevActive );
		}
	}

	render() {
		let { stacked, left, width } = this.state.subMenuStyle;

		this.elements.menuList.toggleClass( 'stacked', stacked );

		if ( stacked ) {
			this.elements.subMenus.css( {
				position: 'static',
				width: '100%',
				left: 'auto',
			} );
		} else {
			this.elements.subMenus.css( {
				position: 'absolute',
				left: left,
				width: width,
			} );
		}

		this.handleSubMenuTransitions();
	}
}
